"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.afterify = void 0;
function afterify(originalMethod, config) {
    const resolvedConfig = Object.assign({ wait: false }, config);
    return function (...args) {
        return __awaiter(this, void 0, void 0, function* () {
            const afterFunc = typeof resolvedConfig.func === 'string'
                ? this[resolvedConfig.func].bind(this)
                : resolvedConfig.func;
            if (resolvedConfig.wait) {
                const response = yield originalMethod.apply(this, args);
                afterFunc({
                    args,
                    response,
                });
                return response;
            }
            const response = originalMethod.apply(this, args);
            afterFunc({
                args,
                response,
            });
            return response;
        });
    };
}
exports.afterify = afterify;
